export default __webpack_public_path__ + "static/media/mom_and_us.ab681d4c.jpg";